import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.includes.js";
import { updateProcessingSettingsFromQC, loadedProcessingConfig, updatePipelineVersion } from 'redux/actions/experimentSettings';
import { updateBackendStatus } from 'redux/actions/backendStatus';
import { replaceLoadedConfigs, clearPlotData } from 'redux/actions/componentConfig';
import { loadCellSets, updateCellSetsClustering, loadCreatedCellSets } from 'redux/actions/cellSets';
import { loadSamples } from 'redux/actions/samples';
import { reloadExperimentInfo } from 'redux/actions/experiments';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import { cellSetsUpdatedMessages } from 'const';
import endUserMessages from 'utils/endUserMessages';
import { qcFinished } from 'redux/actions/global';
var updateTypes = {
  QC: 'qc',
  GEM2S: 'gem2s',
  SEURAT: 'seurat',
  ANNDATA: 'anndata',
  WORK_RESPONSE: 'WorkResponse',
  PLOT_CONFIG_REFRESH: 'PlotConfigRefresh'
};
var experimentUpdatesHandler = function experimentUpdatesHandler(dispatch) {
  return function (experimentId, update) {
    var _update$response;
    if (update.status) {
      dispatch(updateBackendStatus(experimentId, update.status));
    }
    if ((_update$response = update.response) !== null && _update$response !== void 0 && _update$response.error) {
      console.error('Experiment updates error:', update);

      // QC can handle updates even if there are errors
      if (update.type !== updateTypes.QC) return;
    }
    switch (update.type) {
      case updateTypes.QC:
        {
          return onQCUpdate(update, dispatch, experimentId);
        }
      case updateTypes.GEM2S:
        {
          return onGEM2SUpdate(update, dispatch, experimentId);
        }
      case updateTypes.SEURAT:
        {
          return onSeuratUpdate(update, dispatch, experimentId);
        }
      case updateTypes.ANNDATA:
        {
          return onAnndataUpdate(update, dispatch, experimentId);
        }
      case updateTypes.WORK_RESPONSE:
        {
          return onWorkResponseUpdate(update, dispatch, experimentId);
        }
      case updateTypes.PLOT_CONFIG_REFRESH:
        {
          return onPlotConfigRefresh(update, dispatch);
        }
      default:
        {
          console.error("Error, unrecognized message type ".concat(update.type), update);
        }
    }
  };
};
var onQCUpdate = function onQCUpdate(update, dispatch, experimentId) {
  var input = update.input,
    output = update.output,
    pipelineVersion = update.pipelineVersion;
  dispatch(updatePipelineVersion(experimentId, pipelineVersion));

  // If there was an error and no output was generated, return
  if (!output) return;
  var processingConfigUpdate = output.config,
    plotKeysMap = output.plotKeys;
  if (processingConfigUpdate) {
    dispatch(updateProcessingSettingsFromQC(input.taskName, processingConfigUpdate, input.sampleUuid, false));
  }
  var plotKeys = Object.keys(plotKeysMap || {});
  if (plotKeys.length > 0) {
    dispatch(clearPlotData(plotKeys));
  }
  if (update.status.pipeline.status === 'SUCCEEDED') {
    dispatch(qcFinished(experimentId));
  }
};
var onGEM2SUpdate = function onGEM2SUpdate(update, dispatch, experimentId) {
  var _update$output;
  var processingConfig = update === null || update === void 0 || (_update$output = update.output) === null || _update$output === void 0 ? void 0 : _update$output.processingConfig;
  if (processingConfig) {
    dispatch(loadedProcessingConfig(processingConfig, true));
  }

  // If we finished subsetSeurat, then we now know which samples survived the subset
  // So load them
  if ((update === null || update === void 0 ? void 0 : update.taskName) === 'subsetSeurat') {
    dispatch(reloadExperimentInfo());
    dispatch(loadSamples(experimentId));
  }
};
var onWorkResponseUpdate = function onWorkResponseUpdate(update, dispatch, experimentId) {
  var workRequestName = update.taskName;
  if (['ClusterCells', 'ScTypeAnnotate'].includes(workRequestName)) {
    if (workRequestName === 'ClusterCells') {
      dispatch(updateCellSetsClustering(experimentId, ['louvain']));
    } else {
      dispatch(loadCreatedCellSets(experimentId));
    }
    pushNotificationMessage('success', cellSetsUpdatedMessages[workRequestName]);
  }
  if (workRequestName === 'GetExpressionCellSets') {
    // Expression sets are appended to scratchpad.
    dispatch(loadCellSets(experimentId, {
      cellClassesToLoad: ['scratchpad']
    }));
    pushNotificationMessage('success', endUserMessages.SUCCESS_NEW_CLUSTER_CREATED('Custom cell sets'));
  }
};
var onPlotConfigRefresh = function onPlotConfigRefresh(update, dispatch) {
  dispatch(replaceLoadedConfigs(update.updatedConfigs));
};
var onSeuratUpdate = function onSeuratUpdate(update, dispatch, experimentId) {
  // If the pipeline finished we have a new clustering, so fetch it
  if (update.status.seurat.status === 'SUCCEEDED') {
    dispatch(loadCellSets(experimentId, {
      forceReload: true
    }));
  }
};
var onAnndataUpdate = function onAnndataUpdate(update, dispatch, experimentId) {
  // Anndata shares the gem2s pipeline_type bucket, so its status lives under status.gem2s
  // (the type here is 'anndata', but only to select this handler)
  if (update.status.gem2s.status === 'SUCCEEDED') {
    dispatch(loadCellSets(experimentId, {
      forceReload: true
    }));
  }
};
export default experimentUpdatesHandler;
export { updateTypes };